import React from 'react';
import { Spacer } from '../../components/layout/spacers';
import { CustomPageWidget } from '../../pages/custom-page/sections';
import { Coach } from './coach';

export const PensionFinderTemplate = React.memo(({ page }) => {
  const { widget } = page;

  return (
    <>
      <Spacer type='top' />
      <CustomPageWidget {...widget}>
        <Coach />
      </CustomPageWidget>
      <Spacer type='bottom' />
    </>
  );
});
